import PropTypes from 'prop-types';

// For old API response, not GraphQL
const eventPropTypes = PropTypes.shape({
    address1: PropTypes.string,
    address2: PropTypes.string,
    address3: PropTypes.string,
    begins_at: PropTypes.string,
    building: PropTypes.shape({
        address1: PropTypes.string,
        address2: PropTypes.string,
        address3: PropTypes.string,
        city: PropTypes.string,
        country: PropTypes.shape({
            code: PropTypes.string,
            name: PropTypes.string,
        }),
        name: PropTypes.string,
        state_province: PropTypes.shape({
            code: PropTypes.string,
            name: PropTypes.string,
        }),
        zip: PropTypes.string,
    }),
    city: PropTypes.string,
    code: PropTypes.string,
    country: PropTypes.string,
    ends_at: PropTypes.string,
    free_retailer_central: PropTypes.bool,
    functions: PropTypes.arrayOf(
        PropTypes.shape({
            code: PropTypes.string,
            fees: PropTypes.arrayOf(
                PropTypes.shape({
                    auto_enroll: PropTypes.bool,
                    complimentary: PropTypes.bool,
                    description: PropTypes.string,
                    end_date: PropTypes.string,
                    id: PropTypes.string,
                    locale: PropTypes.string,
                    price: PropTypes.number,
                    product_code: PropTypes.string,
                    registrant_class: PropTypes.string,
                    start_date: PropTypes.string,
                })
            ),
            maximum_attendance: PropTypes.number,
            seats_remaining: PropTypes.number,
            title: PropTypes.string,
        })
    ),
    housing_registration_category_id: PropTypes.any,
    housing_registration_id: PropTypes.any,
    id: PropTypes.string,
    locale: PropTypes.string,
    maximum_attendance: PropTypes.number,
    meeting_type: PropTypes.string,
    notes: PropTypes.string,
    online_registration_cutoff: PropTypes.string,
    online_registration_start_date: PropTypes.string,
    refund_cutoff: PropTypes.string,
    registration_allowed: PropTypes.bool,
    seats_remaining: PropTypes.number,
    state_province: PropTypes.string,
    status: PropTypes.string,
    team_members: PropTypes.array,
    time_zone: PropTypes.string,
    title: PropTypes.string,
    view_only: PropTypes.bool,
    zip: PropTypes.string,
});

export default eventPropTypes;
